<div>
    <kendo-treeview 
    [nodes]="items"
    [textField]="titleField"
    [childrenField]="childrenField"
    [filterable]="true"
    kendoTreeViewExpandable
    kendoTreeViewHierarchyBinding
    kendoTreeViewSelectable
    (selectionChange)="onSelectionChange($event)">
    <ng-template kendoTreeViewNodeTemplate let-dataItem
    >
      {{ dataItem[titleField] }}
    </ng-template>
  </kendo-treeview>
</div>